var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isMaintainer)?_c('v-btn',{staticClass:"green white--text",attrs:{"small":""},on:{"click":_vm.start}},[_vm._v(" "+_vm._s(_vm._f("t")('action.login'))+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }